import { Rectangle, Transform, Vector2 } from "../../../../lib/math";
import { TileArea } from "../../../../lib/runescape/coordinates/TileArea";
import { TileTransform } from "../../../../lib/runescape/coordinates/TileTransform";
import { FakeLodash } from "lib/coreutil/FakeLodash";
export var ProcessedCacheTypes;
(function (ProcessedCacheTypes) {
    let Prototype;
    (function (Prototype) {
        function isLoc(prototype) {
            return prototype.id[0] == "loc";
        }
        Prototype.isLoc = isLoc;
        function fromCache(cache) {
            switch (cache.type) {
                case "npc":
                    return {
                        id: cache.id,
                        name: cache.data.name,
                        actions: [],
                        raw: cache.data,
                        size: { x: 1, y: 1 }
                    };
                case "loc":
                    return {
                        id: cache.id,
                        name: cache.data.name,
                        actions: [],
                        raw: cache.data,
                        size: { x: cache.data.width ?? 1, y: cache.data.length ?? 1 }
                    };
            }
        }
        Prototype.fromCache = fromCache;
    })(Prototype = ProcessedCacheTypes.Prototype || (ProcessedCacheTypes.Prototype = {}));
    let PrototypeID;
    (function (PrototypeID) {
        function hash(id) {
            return id[0] + ":" + id[1];
        }
        PrototypeID.hash = hash;
        function equals(a, b) {
            return a[0] == b[0] && a[1] == b[1];
        }
        PrototypeID.equals = equals;
    })(PrototypeID = ProcessedCacheTypes.PrototypeID || (ProcessedCacheTypes.PrototypeID = {}));
    let GroupedInstanceData;
    (function (GroupedInstanceData) {
        function combine(...data) {
            const combined = {};
            data.forEach(group => group.forEach(data => {
                const hash = PrototypeID.hash(data.id);
                if (!combined[hash])
                    combined[hash] = FakeLodash.cloneDeep(data);
                else
                    combined[hash].instances.push(...FakeLodash.cloneDeep(data.instances));
            }));
            return Object.values(combined);
        }
        GroupedInstanceData.combine = combine;
    })(GroupedInstanceData = ProcessedCacheTypes.GroupedInstanceData || (ProcessedCacheTypes.GroupedInstanceData = {}));
    class PrototypeInstance {
        constructor(prototype, instance) {
            this.prototype = prototype;
            this.instance = instance;
            this.box = TileArea.init(this.instance.position, (this.instance.rotation % 2 == 0)
                ? this.prototype.size
                : { x: this.prototype.size.y, y: this.prototype.size.x });
        }
        protoId() {
            return this.prototype.id;
        }
        isLoc() {
            return this.prototype.id[0] == "loc";
        }
        getTransform() {
            const rotation = Transform.rotation((4 - this.instance.rotation) % 4);
            const origin_correction = Rectangle.bottomLeft(Rectangle.from({ x: 0, y: 0 }, Vector2.transform(Vector2.sub(this.prototype.size, { x: 1, y: 1 }), rotation)));
            return TileTransform.chain(TileTransform.translation(Vector2.add(this.instance.position, origin_correction), this.instance.position.level), rotation);
        }
        getInverseTransform() {
            const rotation = Transform.rotation(this.instance.rotation % 4);
            const origin_correction = Rectangle.bottomLeft(Rectangle.from({ x: 0, y: 0 }, Vector2.transform(Vector2.sub(this.prototype.size, { x: 1, y: 1 }), Transform.rotation((4 - this.instance.rotation) % 4))));
            return TileTransform.chain(rotation, TileTransform.translation(Vector2.neg(Vector2.add(origin_correction, this.instance.position)), -this.instance.position.level));
        }
    }
    ProcessedCacheTypes.PrototypeInstance = PrototypeInstance;
    class PrototypeIndex {
        constructor(data, f) {
            this.data = data;
            this.lookup_table = {
                loc: [],
                npc: []
            };
            data.forEach(proto => {
                const is_loc = Prototype.isLoc(proto);
                if (is_loc) {
                    this.lookup_table.loc[proto.id[1]] = {
                        prototype: proto,
                        data: f(proto)
                    };
                }
                else {
                    this.lookup_table.npc[proto.id[1]] = {
                        prototype: proto,
                        data: f(proto)
                    };
                }
            });
        }
        static simple(prototypes) {
            return new PrototypeIndex(prototypes, () => null);
        }
        getEntry(id) {
            const res = this.lookup_table[id[0]][id[1]];
            if (!res)
                console.log(`Missing ${id[1]}`);
            return res;
        }
        lookup(id) {
            return this.getEntry(id).prototype;
        }
        resolve(instance) {
            const resolve = this.lookup(instance.id);
            return new PrototypeInstance(resolve, instance);
        }
        set(proto, value) {
            const entry = this.getEntry(proto);
            if (entry)
                entry.data = value;
        }
        get(id) {
            return this.getEntry(id)?.data;
        }
    }
    ProcessedCacheTypes.PrototypeIndex = PrototypeIndex;
})(ProcessedCacheTypes || (ProcessedCacheTypes = {}));
